import {Injectable} from "@angular/core";
import {environment} from "../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {TicketDTO} from "../model/queue/ticketDTO.model";
import {JoinQueueRequest} from "../model/queue/join-queue-request.model";
import {QueueCategory} from "../model/queue/queue-category.model";
import {AdmissionMotif} from "../model/admission/admission-motif.model";
import {DisplayTicketRequest} from "../model/queue/display-ticket-request.model";

@Injectable({ providedIn: 'root' })
export class QueueService {
    private readonly apiUrl = `${environment.API_URL}/api/queue`;

    constructor(private http: HttpClient) {
    }

    getAllWaitingTicket(page: number = 0, size: number = 10, search: string = "", sortField: string = "number", sortDirection: string = "asc"): Observable<TicketDTO[]> {
        let params = new HttpParams()
            .set('page', page.toString())
            .set('size', size.toString())
            .set('search', search ? search.trim() : '')
            .set('sort', `${sortField},${sortDirection}`);

        return this.http.get<TicketDTO[]>(this.apiUrl, { params });
    }

    join(joinQueueRequest: JoinQueueRequest): Observable<TicketDTO> {
        return this.http.post<TicketDTO>(`${this.apiUrl}/join`, joinQueueRequest);
    }

    getQueueCategory(motif: AdmissionMotif): Observable<QueueCategory> {
        return this.http.get<QueueCategory>(`${this.apiUrl}/${motif.id}`,);
    }

    getServingTicketAndWaitingTicket(): Observable<DisplayTicketRequest> {
        return this.http.get<DisplayTicketRequest>(`${this.apiUrl}/serving`);
    }

    serve(ticket: TicketDTO): Observable<TicketDTO> {
        return this.http.put<TicketDTO>(`${this.apiUrl}/serve/${ticket.id}`,ticket);
    }

    resetQueue(): Observable<void> {
        return this.http.post<void>(`${this.apiUrl}/reset`, {});
    }

    getTicketByUUID(uuid: string): Observable<TicketDTO> {
        return this.http.get<TicketDTO>(`${this.apiUrl}/get/${uuid}`);
    }

    getServerSentEvents() {
        return new Observable(observer => {
            const eventSource = new EventSource(`${this.apiUrl}/stream`);

            eventSource.addEventListener('ticket-update', event => {
                observer.next(JSON.parse(event.data));
            });

            eventSource.onerror = error => {
                // Gérer la reconnexion si nécessaire
            };

            // Nettoyage
            return () => eventSource.close();
        });
    }
}
